import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    FirstName: "",
    LastName: "",
    Email: "",
    Birthday: null,
    Nationality: null,
    CountryOfResidence: null,
    id: 0,
  }
}

export const state = initialState

export const mutations = {
  SET: function (state, data) {
    for (let key in data) {
      if (typeof state[key] !== "undefined") Vue.set(state, key, data[key])
    }
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: function ({ commit }) {
    commit("RESET", initialState())
  },
  FETCH: async function ({ commit, dispatch }) {
    try {
      const resp = await this.$axios.$get("/mangopay/naturaluser/")

      commit("SET", {
        ...resp[0],
        Birthday: resp[0].Birthday * 1000,
        id: Number(resp[0].Id),
      })
    } catch (error) {
      dispatch("RESET")
    }
  },
  UPDATE_ON_SERVER: async function (
    { state, getters, rootState },
    new_natural_user
  ) {
    const sendFn = getters["CAN_PATCH"] ? this.$axios.$patch : this.$axios.$post
    let url = "/mangopay/naturaluser/"

    if (getters["CAN_PATCH"]) url += state.id + "/"
    return await sendFn(url, {
      ...new_natural_user,
      id: undefined,
      Email: rootState.user.email,
      user: rootState.user.id,
      Birthday: new_natural_user.Birthday / 1000,
    })
  },
}

export const getters = {
  INITIAL_STATE: function () {
    return initialState()
  },
  CAN_PATCH: function (state) {
    return state.id > 0
  },
}
